<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="overlay-content" *ngIf="isVisible">
  <div class="panel">
    <div class="panel-header">
      <img class="close-button ml-3" (click)="togglePanel('')" src="/assets/images/close.png" alt="">
      <div class="action-buttons">
        <button class="btn btn-blue" (click)="openDialog()">
          <img class="btn-img" src="/assets/images/clock.png" alt=""> Lead History
        </button>
        <button class="btn btn-light" (click)="togglePanel('')">Cancel</button>
      </div>
    </div>
    <div class="panel-content">
      <div class="table-container">
        <div class="row">
          <div class="col-md-6 mt-3">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td class="sub-head">First Name</td>
                  <td>{{leadObject?.first_name ? leadObject?.first_name : '-'}}</td>
                </tr>
                 <tr>
                  <td class="sub-head">Middle Name</td>
                  <td>{{leadObject?.middle_name ? leadObject?.middle_name : '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Last Name</td>
                  <td>{{leadObject?.last_name ? leadObject?.last_name : '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Email ID</td>
                  <td  style="text-transform: lowercase;word-break: break-word;">{{leadObject?.email ? leadObject?.email : '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Alternate Email ID</td>
                  <td style="text-transform: lowercase;word-break: break-word;">{{leadObject?.alternate_email ? leadObject?.alternate_email :
                    '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Phone Number</td>
                  <td>{{leadObject?.mobile ? leadObject?.mobile : '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Alternate Number</td>
                  <td>{{leadObject?.alternate_mobile ? leadObject?.alternate_mobile : '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Age Group</td>
                  <td>{{leadObject?.age_group ? leadObject?.age_group : '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">DMS Enquiry Number</td>
                  <td>{{leadObject?.dms_enquiry_number ? leadObject?.dms_enquiry_number : '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Product Category</td>
                  <td>{{leadObject?.product_details?.product_category ? leadObject?.product_details?.product_category :
                    '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Product Model</td>
                  <td>{{leadObject?.product_details?.product_model ? leadObject?.product_details?.product_model : '-'}}
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Product Variant</td>
                  <td>{{leadObject?.product_details?.product_variant ? leadObject?.product_details?.product_variant :
                    '-'}}
                </tr>
                <tr>
                  <td class="sub-head">Lead Type</td>
                  <td>{{leadObject?.lead_type ? leadObject?.lead_type : '-'}}</td>
                </tr>
                <tr *ngIf="leadObject?.UTM">
                  <td class="sub-head">UTM</td>
                  <td style="text-transform: lowercase;" class="url-link">
                    <a *ngIf="leadObject?.UTM" href="{{leadObject?.UTM}}" target="_blank">
                      {{leadObject?.UTM ? leadObject?.UTM : ''}}
                    </a>
                    <span *ngIf="!leadObject?.UTM">-</span>
                  </td>
                </tr>
                 <tr *ngIf="leadObject?.utm_details?.utm_source">
                  <td class="sub-head">UTM Source</td>
                  <td class="url-link">
                      {{leadObject?.utm_details?.utm_source || ''}}
                  </td>
                </tr>
                <tr *ngIf="leadObject?.utm_details?.utm_medium">
                  <td class="sub-head">UTM Medium</td>
                  <td class="url-link">
                      {{leadObject?.utm_details?.utm_medium || ''}}
                  </td>
                </tr>
                <tr *ngIf="leadObject?.utm_details?.utm_campaign">
                  <td class="sub-head">UTM Campaign</td>
                  <td class="url-link">
                      {{leadObject?.utm_details?.utm_campaign || ''}}
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Assign To</td>
                  <!-- <td>  {{ leadObject?.assign_to_name ? leadObject?.assign_to_name :'-' }}</td> -->
                  <td style="padding: 5px;"> <button class="btn btn-assignto" *ngIf="leadObject?.assign_to_name">
                    {{ leadObject?.assign_to_name ? leadObject?.assign_to_name :'-' }}
                  </button> 
                  </td>
                </tr>
                <!-- <tr>
                  <td class="sub-head">Base Lead Source</td>
                  <td>{{leadObject.base_lead_source || '-'}}</td>
                </tr> -->
                <tr>
                  <td class="sub-head">Lead Source</td>
                  <td>{{leadObject?.lead_source ? leadObject?.lead_source : '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Sub Source</td>
                  <td>{{leadObject?.lead_sub_source ? leadObject?.lead_sub_source : '-'}}</td>
                </tr>    
                <tr *ngIf="leadObject?.reference_type_id  == 17">
                  <td class="sub-head">Reference Type</td>
                  <td>{{leadObject?.reference_type || '-'}}</td>
                </tr>
                <tr *ngIf="leadObject?.reference_type_id  == 17">
                  <td class="sub-head">Reference By</td>
                  <td>{{leadObject?.reference_by || '-'}}</td>
                </tr>         
              </tbody>
            </table>
          </div>
          <div class="col-md-6 mt-3">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td class="sub-head">Lead Captured Date/Time</td>
                  <td> <span class="date">{{ leadObject?.lead_capture_date | date: 'dd-MM-yyyy ' }}, {{
                      leadObject?.lead_capture_date | date: 'hh:mm a' }}</span>
                    <!-- <span class="time">{{ leadObject?.createdAt | date: 'hh:mm a' }}</span> -->
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Lead ID</td>
                  <td>{{ leadObject?.lead_id ? leadObject?.lead_id :'-' }}</td>
                </tr>
                 <tr>

                  <td class="sub-head">Reference Lead ID</td>
                  <td>{{leadObject.unique_reference_number || '-'}}</td>
                </tr>
                <!-- <tr>
                  <td class="sub-head">Qualify ID</td>
                  <td>{{ leadObject?.qualify_id ? leadObject?.qualify_id :'-' }}</td>
                </tr> -->
                <tr *ngIf="leadObject?.booking_id">
                  <td class="sub-head">Booking ID</td>
                  <td>{{ leadObject?.booking_id ? leadObject?.booking_id :'-' }}</td>
                </tr>
                <tr *ngIf="leadObject?.retail_id">
                  <td class="sub-head">Retail ID</td>
                  <td>{{ leadObject?.retail_id ? leadObject?.retail_id :'-' }}</td>
                </tr>
                <!-- <tr>
                  <td class="sub-head">Status</td>
                  <td  [ngClass]="{'re-engaged' : leadObject?.lead_status?.toLowerCase()== 're-engaged'}">{{leadObject.lead_status ? leadObject.lead_status: '-'}}</td>
                </tr> -->
                <tr>
                  <td class="sub-head">Lead Stage</td>
                  <td style="padding:5px;"> <button class="btn btn-higlight" *ngIf="leadObject?.current_stage?.stage">
                    {{leadObject?.current_stage?.stage ? leadObject?.current_stage?.stage : '-'}}
                  </button> 
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Lead Qualification</td>
                  <td  [ngClass]="{
                    'priority-td': leadObject?.current_stage?.lead_priority
                }"> <button class="btn"  [ngClass]="{
                    'hot-class': leadObject?.current_stage?.lead_priority?.toLowerCase() == 'hot',
                    'warm-class': leadObject?.current_stage?.lead_priority?.toLowerCase() == 'warm',
                    'cold-class': leadObject?.current_stage?.lead_priority?.toLowerCase() == 'cold'
                  }" *ngIf="leadObject?.current_stage?.lead_priority">
                    {{leadObject?.current_stage?.lead_priority ? leadObject?.current_stage?.lead_priority : '-'}}
                  </button>
                  <ng-container *ngIf="!leadObject?.current_stage?.lead_priority">
                    -
                  </ng-container> 
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">call records</td>
                  <td style="padding:10px 8px 8px 10px">
                    <img src="/assets/images/play.png" alt="" style="cursor: pointer;" title="Open Audio"  *ngIf="leadObject.audio_path != null && leadObject.call_status == 'ANSWER' || leadObject.audio_path != null && leadObject.call_status == 'Answered'"
                    (click)="openAudioDialog()"> 
                    <!-- <button title="Click to Open" class="btn btn-light-audio"
                      *ngIf="leadObject.audio_path != null && leadObject.call_status == 'ANSWER'"
                      (click)="openAudioDialog()"> <img src="/assets/images/headset.png" alt=""> Open Audio Player</button> -->
                    <span *ngIf="leadObject.call_status != 'ANSWER'"> -</span>
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Finance Source</td>
                  <td>{{ leadObject?.finance || '-' }}</td>
                </tr>
                <tr>
                  <td class="sub-head">Customer Requirement</td>
                  <td>{{leadObject?.current_stage?.customer_requirement ?
                    leadObject?.current_stage?.customer_requirement : '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Customer Type</td>
                  <td>{{leadObject?.customer_type || '-'}}</td>
                </tr>
                <tr *ngIf="leadObject?.customer_type_id  == 1">
                  <td class="sub-head">Company Name</td>
                  <td>{{leadObject?.company_name || '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Buyer Type</td>
                  <td>{{leadObject?.current_stage?.customer_interest || '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Interest Level</td>
                  <td>{{leadObject?.current_stage?.interest_level ? leadObject?.current_stage?.interest_level : '-'}}
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Dealer</td>
                  <td>{{leadObject?.outlet_details?.outlet ? leadObject?.outlet_details?.outlet : '-' }}</td>
                </tr>
                <tr>
                  <td class="sub-head">Parent Dealer</td>
                  <td>{{leadObject?.outlet_details?.parent_dealer ? leadObject?.outlet_details?.parent_dealer : '-' }}
                  </td>
                </tr>
                <tr>
                  <td class="sub-head">Region</td>
                  <td>{{leadObject?.outlet_details?.region ? leadObject?.outlet_details?.region : '-' }}</td>
                </tr>
                <tr>
                  <td class="sub-head">Zone</td>
                  <td>{{leadObject?.outlet_details?.zone ? leadObject?.outlet_details?.zone : '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Message</td>
                  <td>{{leadObject.message ? leadObject.message : '-'}}</td>
                </tr>
                <tr>
                  <td class="sub-head">Remarks</td>
                  <td>
                    <div *ngIf="leadObject?.current_stage?.remarks; else noRemarks">
                      <div *ngFor="let remark of leadObject?.current_stage?.remarks | splitLines; let i =index;"
                        class="remark-item">
                        <span style="font-size: 13px;"> {{i+1}}. {{ remark }}</span>
                      </div>
                    </div>
                    <ng-template #noRemarks>
                      -
                    </ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- <div class="icon-container">
          <img src="/assets/images/message.png" alt="SMS">
          <img src="/assets/images/whatsapp.png" alt="WhatsApp">
          <img src="/assets/images/email.png" alt="Email">
        </div> -->
      </div>
    </div>
  </div>
</div>


<ng-template #audioDialog>
  <h2 mat-dialog-title class="ml-2">Audio Player</h2>
  <img class="close-audio-xbutton" mat-dialog-close src="/assets/images/close.png" alt="" (click)="closeAudio()">
  <mat-dialog-content>
    <div class="audio-player">
      <audio controls>
        <source [src]="'data:' + leadObject.audioMimeType + ';base64,' + leadObject.audioData" >
        Your browser does not support the audio element.
      </audio>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions class="d-flex justify-content-end">
    <button mat-dialog-close class="btn white-btn mr-2" type="button" (click)="closeAudio()">Close</button>
  </div>
</ng-template>